import React, { useEffect, useState } from 'react';
import { classIf } from '../data/utils/classIf';
import { getBetDescription } from '../data/utils/getBetDescription';
import { getNumberOfColsMobile } from '../data/utils/getNumberOfColsMobile';
import { LiveMatchContext } from '../live/match/LiveMatchDataFetcher';
import { MatchContext } from '../prematch/match/MatchDataFetcher';
import { BetsExpandCollapseContext } from './BetsExpandCollapseContext';
import CashoutLabel from './CashoutLabel';
import Odd from './Odd';

function Bet(props) {
    const betsExpandCollapseContext = React.useContext(BetsExpandCollapseContext);
    const matchContext = React.useContext(MatchContext);
    const liveMatchContext = React.useContext(LiveMatchContext);
    const context = matchContext || liveMatchContext;
    const betId = `${props.id}_${props.handicap}`;
    const [expanded, setExpanded] = useState(true);

    function handleClick() {
        if (context && context.favoritesSelected) {
            setExpanded(!expanded);
        } else {
            betsExpandCollapseContext && betsExpandCollapseContext.toggleBetCollapsedById(props.toggleCollapseId)
        }
    }

    function toggleFavorite(e) {
        e.stopPropagation();
        context.toggleFavorite(context.match.sportRef, betId);
    }

    useEffect(() => {
        if (!context || (context && !context.favoritesSelected)) {
            betsExpandCollapseContext && betsExpandCollapseContext.toggleBetCollapsedById(props.toggleCollapseId, !props.expanded);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.toggleCollapseId]);

    const show = (context && context.favoritesSelected) ? expanded : props.expanded;

    return (
        <li className={"list-element-quota" + classIf(show, 'show')}>
            <div className="list-element" onClick={handleClick}>
                <div className="list-element-text">
                    {getBetDescription(props, true)}
                    <CashoutLabel bet={props} />
                </div>
                {context &&
                    <div className="pin-toggle mr-4" onClick={toggleFavorite}>
                        <i className={"fas fa-thumbtack rotate-45" + classIf(context.isMarketFavorite(context.match.sportRef, betId), 'selected')}></i>
                    </div>
                }
                <div className="d-flex align-items-center mr-4 ml-4">
                    <span className="arrow arrow-expand"></span>
                </div>
            </div>
            {show &&
                <div className={"esiti-container grid-columns-" + getNumberOfColsMobile(props.odds.length)}>
                    {props.odds.map((odd, i) => {
                        return <Odd key={i} {...odd} />;
                    })}
                </div>
            }
        </li>
    );
}

export default Bet;